(function()
{
	//Include classes
	var Application = include("springroll.Application");
	var Debug = include("springroll.Debug", false);

	/**
	 * Mixin for the Arrow animation
	 * @class Arrow
	 */
	var Arrow = function()
	{
		/**
		 * Reference to the application
		 * @property {springroll.Application} app
		 */
		this.app = Application.instance;
		this.framerate = 30;
		this.visible = false;
	};

	//Prototype reference
	var p = Arrow.prototype;

	/**
	 * @param {boolean|String} show
	 */
	p.show = function(show)
	{
		// Don't show the arrow unless we feed it a proper position from the config
		if (show === false)
		{
			this.visible = false;
		}
		else
		{
			this.visible = true;
			var pos = this.app.config.ui.arrow[show];
			this.rotation = pos.rotation;
			this.x = pos.x;
			this.y = pos.y;
		}
	};

	/**
	 * destroy and don't use after this
	 * @method destroy
	 */
	p.destroy = function()
	{
		if (this.parent)
		{
			this.parent.removeChild(this);
		}
		this.app = null;
	};

	//Assign to namespace
	namespace("nature").Arrow = Arrow;
}());
